<template>
  <div class="container">
    <div class="nav-container">
      <div class="header">
        <img class="back" src="@/images/back.png" @click="goBack" />
      </div>
    </div>
    <div class="info-view">
      <div class="phone-container" v-if="state.active == 0">
        <span class="t-f26-c1a font-bold">欢迎使用</span>
        <div class="t-f14-c66">请输入您的手机号码</div>
        <van-field
          style="margin-top: 30px; border-radius: 20px"
          v-model="phoneValue"
          type="tel"
          placeholder="请输入手机号"
          maxlength="11"
        />
        <div class="m-20">
          <van-button
            round
            type="primary"
            size="normal"
            class="main-btn"
            :disabled="phoneValue.length < 3"
            @click="setSmsCode"
            >获取验证码</van-button
          >
        </div>
      </div>
      <div class="code-container" v-if="state.active == 1">
        <span class="t-f26-c1a font-bold">请输入验证码</span>
        <div class="t-f14-c66">验证码已发送至 {{ phoneValue }}</div>
        <van-password-input
          style="margin-top: 30px"
          :value="codeValue"
          :mask="false"
          :gutter="15"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <van-number-keyboard
          v-model="codeValue"
          :show="showKeyboard"
          @blur="showKeyboard = false"
        />
        <div class="code-time-container">
          <span class="t-f14-cf19321 font-bold" @click="setSmsCode">{{
            state.codeText
          }}</span>
          <span class="t-f14-c99" v-if="codeNumber >= 0 && codeNumber < 60">
            后重新获取验证码</span
          >
        </div>

        <div class="m-20">
          <van-button
            round
            type="primary"
            size="normal"
            class="main-btn"
            :disabled="codeValue.length < 6 || !checked"
            @click="authPhone"
            >登录</van-button
          >
        </div>
        <div class="m-t-15">
          <van-checkbox v-model="checked">
            <template #icon="props">
              <img
                class="checked-icon"
                src="@/images/login_page_privacy_check.png"
                v-if="!props.checked"
              />
              <img
                class="checked-icon"
                src="@/images/login_page_privacy_checked.png"
                v-if="props.checked"
              />
            </template>
            登录或注册即代表您同意《隐私政策》和《服务条款》</van-checkbox
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, onUnmounted } from "vue";
import request from "@/api/request";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import tokenHelper from "@/helpers/token_helper";
import userHelper from "@/helpers/user_helper";
// import { useStore } from "vuex";
let state;
let phoneValue = ref(""); //手机号
let codeValue = ref(""); //验证码
let checked = ref(false); //协议复选框
let isGetCode = ref(false); //是否可以重新获取验证码
let codeNumber = ref(60);
let router;
let timeInterval;
// let stateContext;
export default {
  setup() {
    router = useRouter();
    // stateContext = useStore();
    state = reactive({
      active: 0,
      codeText: "60S",
    });
    const showKeyboard = ref(true); //底部键盘
    
    // 组件卸载时清理定时器
    onUnmounted(() => {
      if (timeInterval) {
        clearInterval(timeInterval);
        timeInterval = null;
      }
    });
    
    return {
      phoneValue,
      setSmsCode,
      state,
      codeValue,
      checked,
      isGetCode,
      codeNumber,
      authPhone,
      router,
      goBack,
      showKeyboard,
    };
  },
};

//返回重新输入手机号
function goBack() {
  if (state.active == 0) {
    router.back();
  }
  if (state.active == 1) {
    isGetCode.value = false;
    clearInterval(timeInterval);
    state.active = 0;
  }
}
//60秒倒计时可重新获取验证码
function countCodeDown() {
  timeInterval = setInterval(function () {
    if (codeNumber.value == 0) {
      codeNumber.value = 60;
      state.codeText = "重新获取";
      isGetCode.value = false;
      clearInterval(timeInterval);
    } else {
      codeNumber.value--;
      state.codeText = codeNumber.value + "S";
      isGetCode.value = true;
    }
  }, 1000);
}
//认证手机号
function authPhone() {
  request
    .bindPhone({
      phone_number: phoneValue.value,
      sms_code: codeValue.value,
      oauth: router.currentRoute.value.params.id,
    })
    .then((res) => {
      tokenHelper.storeTokens(res.data.user.token);
      userHelper.storeUserinfo(res.data.user);
      Toast("登录成功!");
      // stateContext.commit("setHomeRouter", "user");
      router.replace(userHelper.readRouterSession());
    });
}
//发送验证码
function setSmsCode() {
  if (isGetCode.value) {
    isGetCode.value = true;
    return;
  }
  request.getSmsCode({ phone_number: phoneValue.value }).then((res) => {
    state.active = 1;
    Toast(res.data.result);
    countCodeDown();
  });
}
</script>
<style scoped>
body {
  background: #fff;
}
.container {
  flex-direction: column;
  position: relative;
  height: 100vh !important;
}
.header {
  height: 45px;
  background: #fff;
  font-size: 18px;
  color: #333;
  text-align: center;
  line-height: 45px;
  position: relative;
}

.back {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
}
.info-view {
  margin: 30px;
}
.phone-container {
  margin-top: 30px;
}
.main-btn {
  border-radius: 24px;
}
.wechat-login-container {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
.wechat-icon {
  margin-top: 20px;
  height: 50px;
  width: 50px;
}
.code-container {
  margin-top: 30px;
}
.code-time-container {
  margin-top: 15px;
}
.checked-icon {
  height: 15px;
  margin-top: 5px;
}
</style>
<style lang="scss" scoped>
::v-deep .van-field__body {
  line-height: 30px;
  font-size: 20px;
  color: #1a1a1a;
  font-weight: bold;
}
::v-deep .van-password-input {
  margin: 0px;
}
::v-deep [class*="van-hairline"]::after {
  border: none;
}
::v-deep .van-password-input__security {
  border: none;
}
::v-deep .van-password-input__security li {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}
::v-deep .van-checkbox__label {
  font-size: 12px;
  color: #1a1a1a;
}
::v-deep .van-checkbox {
  align-items: inherit;
}
</style>